import React from 'react'
import CustomTabs from '../../CommonElements/CommonTabs/CustomTabs'
import MeterForms from '../FormsTariff/MeterForms'
function MeterFlow({setTitle}) {
    const tabs = [
        { label: 'Meter',content:<MeterForms setTitle={setTitle}/> },
    ]

  return (
    <CustomTabs tabs={tabs}/>
  )
}

export default MeterFlow